/**
 * useKiaanAccess — which Kiaan tabs this user gets.
 *
 * Reads the existing permissions endpoint through `useMyPermissions`
 * (fails closed: while loading or on error everything is false, so Dev mode
 * is never in the DOM for a user the server did not say yes to).
 *
 * Keys mirror backend `permission-catalog.ts` (plan Task 2).
 */
import { useMyPermissions, can } from '../../hooks/useMyPermissions';

export interface KiaanAccess {
  devMode: boolean;
  reportBug: boolean;
  manageAgents: boolean;
  manageKnowledge: boolean;
  manageKeys: boolean;
  loading: boolean;
}

export function useKiaanAccess(): KiaanAccess {
  const { permissions, loading } = useMyPermissions();
  return {
    devMode: can(permissions, 'kiaan_dev_mode'),
    reportBug: can(permissions, 'kiaan_report_bug'),
    manageAgents: can(permissions, 'kiaan_manage_agents'),
    manageKnowledge: can(permissions, 'kiaan_manage_knowledge'),
    manageKeys: can(permissions, 'kiaan_manage_keys'),
    loading,
  };
}
